import { Job } from '@empathybroker/tsclient-index/dist/models/job';

import { IndexState, MutationClass } from '../../../models';

export class SetJobsMutation implements MutationClass {

  public static execute(state: IndexState, jobs: Job[]): void {
    state.jobs = jobs;
  }

}
